import type { IconProps } from './types/types';

const FolderDashedOutlinedIcon = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4 31.1737H32.7863C33.4975 31.1737 34.0721 30.5991 34.0721 29.888V26H31.1792V28.2808H27.4V31.1737ZM34.0721 18V22.6H31.1792V18H34.0721ZM31.1792 14.6V12.3058H27.4V9.41296H32.7863C33.4975 9.41296 34.0721 9.98751 34.0721 10.6987V14.6H31.1792ZM24 12.3058V9.41296H19.4V12.3058H24ZM24 28.2808V31.1737H19.4V28.2808H24ZM16 7.15343V11.157L12.3957 7.70939H11.4V4.81653H13.4283C13.5104 4.81723 13.5893 4.84878 13.6493 4.90492L16 7.15343ZM16 31.1737V28.2808H11.4V31.1737H16ZM8 7.70939H4.82206V11.6H1.9292V6.10224C1.9292 5.39108 2.50375 4.81653 3.21491 4.81653H8V7.70939ZM4.82206 21.6V15H1.9292V21.6H4.82206ZM4.82206 25V28.2808H8L8 31.1737H3.21491C2.50375 31.1737 1.9292 30.5991 1.9292 29.888V25H4.82206Z"
      />
    </svg>
  );
};
export default FolderDashedOutlinedIcon;
